import React, { useEffect } from "react";
import parse from "html-react-parser";

const Embed = ({ embed }) => {
  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);

  return (
    <div>
      {parse(embed, {
        replace(domNode) {
          if (domNode.type === "script") {
            const script = document.createElement("script");
            script.src = domNode.attribs.src;
            script.async = true;
            document.head.appendChild(script);
          }
        },
      })}
    </div>
  );
};

export default Embed;
